import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageFrame } from '../../components/PageFrame';
import { SafeExitLink } from './SafeExitLink';

// Pre-session focus exercise (design spec: 2026-09-11-focus-exercise-design.md).
// Sits between SessionIntroduction's "Start" (which already sent the real
// start action) and the first question on PracticeTask. Pure client-side UI
// -- no network call, nothing to fail, so no error/loading state exists here
// unlike every other learner screen. Auto-advances after 10 seconds so a
// learner who is already settled isn't stuck waiting on a screen with
// nothing to click; "I'm ready" lets them continue sooner, on their own
// terms, never a forced wait.
const AUTO_ADVANCE_MS = 10_000;

export function FocusMoment() {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  function handleContinue() {
    void navigateRef.current('/learn/practice', { replace: true });
  }

  useEffect(() => {
    const timer = setTimeout(handleContinue, AUTO_ADVANCE_MS);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <PageFrame title="Let's get ready" audience="learner">
      <div
        aria-hidden="true"
        className="mx-auto mt-8 size-32 animate-[dm-breathe_4s_ease-in-out_infinite] rounded-full bg-mint"
      />
      {/* Centred under the circle (the text used to sit left-aligned
          below a centred circle). */}
      <p className="mt-8 text-center text-lg text-ink-soft">
        Take a slow breath in… and out.
      </p>
      <p className="mt-2 text-center text-muted">
        When you're ready, we'll begin.
      </p>

      <div className="mt-8 flex justify-center">
        <button
          type="button"
          className="dm-btn-primary w-full sm:w-auto sm:min-w-44"
          onClick={handleContinue}
        >
          I'm ready
        </button>
      </div>

      <SafeExitLink />
    </PageFrame>
  );
}
